import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { IWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useMemo } from "react";
import { ElementToPrint } from "share-components/templates/print/element";
import { TEXT_PRINT_COLOR, TEXT_PRINT_FONT_WEIGHT } from "../const";

export const useBackPage1Elements = ({
  workOrderPoDetail,
}: {
  workOrderPoDetail: IWorkOrderPo;
  fontWeight?: number | string;
}) => {
  const customerDisplay = workOrderPoDetail?.customerDisplay;
  const acceptanceProgress = workOrderPoDetail?.acceptanceProgress;
  const acceptanceStandardDisplay =
    workOrderPoDetail?.acceptanceStandardDisplay;

  const backPage1Elements = useMemo<ElementToPrint[]>(() => {
    const elements: ElementToPrint[] = [
      {
        name: "newElement1",
        value: customerDisplay?.dealingName || "",
        top: "3.54cm",
        left: "7.64cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "6.48cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement2",
        value: workOrderPoDetail?.purchaseOrderItem?.product?.code || "",
        top: "3.58cm",
        left: "16.20cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.29cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement3",
        value: dateTimeDisplay(workOrderPoDetail?.date) || "",
        top: "6.27cm",
        left: "5.08cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "6.77cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement4",
        value: workOrderPoDetail?.woNumber || "",
        top: "6.92cm",
        left: "5.15cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "6.80cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement5",
        value: workOrderPoDetail?.woBatchNumber || "",
        top: "7.60cm",
        left: "5.18cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "6.75cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement6",
        value: numberFormatAsString(
          workOrderPoDetail?.productionAmount?.toString() || "",
        ),
        top: "8.29cm",
        left: "5.20cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "6.75cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement7",
        value: workOrderPoDetail?.purchaseOrder?.poNumber || "",
        top: "6.22cm",
        left: "16.07cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.07cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement8",
        value: dateTimeDisplay(workOrderPoDetail?.purchaseOrder?.poDate) || "",
        top: "6.90cm",
        left: "16.16cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.00cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement9",
        value:
          dateTimeDisplay(workOrderPoDetail?.purchaseOrderItem?.deliveryDate) ||
          "",
        top: "7.60cm",
        left: "16.20cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.07cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement10",
        value: numberFormatAsString(
          workOrderPoDetail?.purchaseOrderItem?.quantityStandard?.toString() ||
            "",
        ),
        top: "8.30cm",
        left: "16.12cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.13cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement11",
        value: dateTimeDisplay(acceptanceProgress?.date) || "",
        top: "11.28cm",
        left: "7.68cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.78cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement12",
        value: acceptanceProgress?.operator || "",
        top: "11.24cm",
        left: "13.14cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.51cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement14",
        value: dateTimeDisplay(acceptanceProgress?.completedDate) || "",
        top: "11.28cm",
        left: "17.92cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.83cm",
        textWrap: "nowrap",
      },

      {
        name: "newElement17",
        value: acceptanceStandardDisplay?.note || "",
        top: "13.41cm",
        left: "4.33cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "16.06cm",
        textWrap: "nowrap",
      },

      {
        name: "newElement33",
        value: numberFormatAsString(
          acceptanceProgress?.printPaperAmount?.toString() || "",
        ),
        top: "21.14cm",
        left: "6.36cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.35cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement35",
        value: numberFormatAsString(
          acceptanceProgress?.amount?.toString() || "",
        ),
        top: "21.13cm",
        left: "17.19cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.46cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement45",
        value: numberFormatAsString(
          acceptanceProgress?.printPaperCompletedAmount?.toString() || "",
        ),
        top: "23.90cm",
        left: "6.50cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.14cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement47",
        value: numberFormatAsString(
          acceptanceProgress?.completedAmount?.toString() || "",
        ),
        top: "23.91cm",
        left: "17.21cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.38cm",
        textWrap: "nowrap",
      },
      {
        name: "productName",
        value: workOrderPoDetail?.purchaseOrderItem?.product?.name || "",
        top: "4.22cm",
        left: "7.05cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "7.12cm",
        textWrap: "nowrap",
      },
      {
        name: "barcode",
        value: workOrderPoDetail?.purchaseOrderItem?.product?.barcode || "",
        top: "4.26cm",
        left: "16.12cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.45cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement21",
        value: numberFormatAsString(
          acceptanceProgress?.firstGradeAmountPaper?.toString() || "",
        ),
        top: "21.82cm",
        left: "6.36cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.38cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement22",
        value: numberFormatAsString(
          acceptanceProgress?.secondGradeAmountPaper?.toString() || "",
        ),
        top: "22.53cm",
        left: "6.36cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.35cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement23",
        value: numberFormatAsString(
          acceptanceProgress?.rejectedAmountPaper?.toString() || "",
        ),
        top: "23.26cm",
        left: "6.36cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.41cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement24",
        value: numberFormatAsString(
          acceptanceProgress?.firstGradeAmountPcs?.toString() || "",
        ),
        top: "21.79cm",
        left: "17.19cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.46cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement25",
        value: numberFormatAsString(
          acceptanceProgress?.secondGradeAmountPcs?.toString() || "",
        ),
        top: "22.50cm",
        left: "17.19cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.51cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement26",
        value: numberFormatAsString(
          acceptanceProgress?.rejectedAmountPcs?.toString() || "",
        ),
        top: "23.20cm",
        left: "17.19cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.46cm",
        textWrap: "nowrap",
      },
    ];
    return elements.map((element) => ({
      ...element,
      fontWeight: TEXT_PRINT_FONT_WEIGHT,
      textColor: TEXT_PRINT_COLOR,
    }));
  }, [
    acceptanceProgress?.amount,
    acceptanceProgress?.completedAmount,
    acceptanceProgress?.completedDate,
    acceptanceProgress?.date,
    acceptanceProgress?.firstGradeAmountPaper,
    acceptanceProgress?.firstGradeAmountPcs,
    acceptanceProgress?.operator,
    acceptanceProgress?.printPaperAmount,
    acceptanceProgress?.printPaperCompletedAmount,
    acceptanceProgress?.rejectedAmountPaper,
    acceptanceProgress?.rejectedAmountPcs,
    acceptanceProgress?.secondGradeAmountPaper,
    acceptanceProgress?.secondGradeAmountPcs,
    acceptanceStandardDisplay?.note,
    customerDisplay?.dealingName,
    workOrderPoDetail?.date,
    workOrderPoDetail?.productionAmount,
    workOrderPoDetail?.purchaseOrder?.poDate,
    workOrderPoDetail?.purchaseOrder?.poNumber,
    workOrderPoDetail?.purchaseOrderItem?.deliveryDate,
    workOrderPoDetail?.purchaseOrderItem?.product?.barcode,
    workOrderPoDetail?.purchaseOrderItem?.product?.code,
    workOrderPoDetail?.purchaseOrderItem?.product?.name,
    workOrderPoDetail?.purchaseOrderItem?.quantityStandard,
    workOrderPoDetail?.woBatchNumber,
    workOrderPoDetail?.woNumber,
  ]);
  return { backPage1Elements };
};
